import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CommandDialog, CommandInput, CommandList, CommandEmpty, CommandGroup, CommandItem } from "@/components/ui/command";
import { LayoutDashboard, BookOpen, ListChecks, CalendarDays, Timer, BarChart3, User, Settings, Sparkles, Plus, Moon, Sun } from "lucide-react";
import { useTheme } from "@/contexts/ThemeContext";

export function CommandPalette({ open, setOpen, onAI }) {
    const navigate = useNavigate();
    const { toggle } = useTheme();

    const go = (path) => { setOpen(false); navigate(path); };

    return (
        <CommandDialog open={open} onOpenChange={setOpen} data-testid="command-palette">
            <CommandInput placeholder="Search actions, pages, courses…" data-testid="command-input" />
            <CommandList>
                <CommandEmpty>No results found.</CommandEmpty>
                <CommandGroup heading="Navigate">
                    <CommandItem onSelect={() => go("/app")} data-testid="cmd-nav-dashboard"><LayoutDashboard className="mr-2 w-4 h-4" /> Dashboard</CommandItem>
                    <CommandItem onSelect={() => go("/app/courses")}><BookOpen className="mr-2 w-4 h-4" /> Courses</CommandItem>
                    <CommandItem onSelect={() => go("/app/assignments")}><ListChecks className="mr-2 w-4 h-4" /> Assignments</CommandItem>
                    <CommandItem onSelect={() => go("/app/calendar")}><CalendarDays className="mr-2 w-4 h-4" /> Calendar</CommandItem>
                    <CommandItem onSelect={() => go("/app/focus")}><Timer className="mr-2 w-4 h-4" /> Focus Timer</CommandItem>
                    <CommandItem onSelect={() => go("/app/analytics")}><BarChart3 className="mr-2 w-4 h-4" /> Analytics</CommandItem>
                    <CommandItem onSelect={() => go("/app/profile")}><User className="mr-2 w-4 h-4" /> Profile</CommandItem>
                    <CommandItem onSelect={() => go("/app/settings")}><Settings className="mr-2 w-4 h-4" /> Settings</CommandItem>
                </CommandGroup>
                <CommandGroup heading="Quick actions">
                    <CommandItem onSelect={() => go("/app/courses?new=1")}><Plus className="mr-2 w-4 h-4" /> New Course</CommandItem>
                    <CommandItem onSelect={() => go("/app/assignments?new=1")}><Plus className="mr-2 w-4 h-4" /> New Assignment</CommandItem>
                    <CommandItem onSelect={() => go("/app/focus?start=1")}><Timer className="mr-2 w-4 h-4" /> Start Focus Session</CommandItem>
                    <CommandItem onSelect={() => { setOpen(false); onAI?.(); }} data-testid="cmd-open-ai"><Sparkles className="mr-2 w-4 h-4" /> Ask StudySphere AI</CommandItem>
                    <CommandItem onSelect={() => { setOpen(false); toggle(); }}><Sun className="mr-2 w-4 h-4" /> Toggle Theme</CommandItem>
                </CommandGroup>
            </CommandList>
        </CommandDialog>
    );
}
